import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { ButtonPromo, Margin, TextPromo } from 'components/ui'
import { Space } from 'components/ui/Space/Space'
import { Flex } from 'components/uiKit'
import { sendAdriverEvent } from 'utils/adriver/sendAdriverEvent'
import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { AuthRoutesEnum, LKRoutesEnum, PromoGeRoutesEnum } from 'shared/constants/routes'
import { SCROLL_TO_ID } from 'shared/constants/values'
import { AdriverEventType, EventType } from 'types/types'

import { openPickPointLink } from '../../data'
import { MapGe } from '../../PromoPageGe/Sections/Map/MapGe'
import { PromoPageKeys } from '../../types'
import { Map } from '../Map/Map'
import { LimitedOfferSpecial } from './LimitedOfferSpecial/LimitedOfferSpecial'

import heroImgM from 'assets/img/promo-page/heroBgM.webp'
import heroImg from 'assets/img/promo-page/heroBgNew.webp'
import heroImgSD from 'assets/img/promo-page/heroBgNew-sd.webp'
import heroImgT from 'assets/img/promo-page/heroBgNew-t.webp'
import s from './Hero.module.scss'

export const Hero: FC = () => {
  const { appStore } = useStore()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isTablet, isMobile, isSTablet, isSDesktop } = useResize()

  const getKey = (key: string) => `${PromoPageKeys.hero}.${key}`
  const getSharedKey = (key: string) => `${PromoPageKeys.shared}.${key}`

  const getImgSrc = () => {
    if (isMobile) {
      return heroImgM
    } else if (isTablet) {
      return heroImgT
    } else if (isSDesktop) {
      return heroImgSD
    }
    return heroImg
  }

  const buttonHero = () => (
    <ButtonPromo
      variant="pink"
      className={s.button}
      onClick={() => {
        if (isGeDomain()) {
          sendAdriverEvent(AdriverEventType.openPVZ)
        } else {
          sendEvent(EventType.PVZOpen, { location: 'Главная' })
        }
        if (!isGeDomain() && !appStore?.user.authenticated) {
          navigate(openPickPointLink.path)
        } else {
          navigate(
            isGeDomain()
              ? PromoGeRoutesEnum.login
              : appStore.needRegistration
                ? AuthRoutesEnum.registration
                : LKRoutesEnum.orderCreate,
          )
        }
      }}
    >
      {t(getSharedKey('Открыть ПВЗ'))}
    </ButtonPromo>
  )

  return (
    <section>
      <div id={SCROLL_TO_ID.heroHome} />
      <div className={`contentWrapper ${s.hero}`}>
        {isGeDomain() ? (
          <Space size={!isTablet ? 270 : !isMobile ? 500 : 300} />
        ) : (
          <Space size={!isSDesktop ? 312 : !isSTablet ? 490 : 380} />
        )}
        {isGeDomain() ? (
          <>
            <div id={SCROLL_TO_ID.heroForm} className={s.textContainer}>
              <TextPromo
                color="white"
                size={isMobile ? 's23' : isTablet ? 's40' : 's70'}
                weight="w700"
                className={s.title}
              >
                {t(getKey('Вашему городу'))}
              </TextPromo>
              <TextPromo
                color="white"
                size={isMobile ? 's23' : isTablet ? 's40' : 's70'}
                weight="w700"
                className={s.title}
              >
                {t(getKey('нужен новый'))}
              </TextPromo>
              <TextPromo
                color="white"
                size={isMobile ? 's23' : isTablet ? 's40' : 's70'}
                weight="w700"
                className={s.title}
              >
                {t(getKey('пункт выдачи'))}
              </TextPromo>
            </div>
            <Space size={isMobile ? 16 : 24} />
            <div className={s.textContainer}>
              <TextPromo color="white" size={!isMobile ? 's24' : 's16'} fontFamily="ASLHauss">
                {t(getKey('Начните свой бизнес'))}
                {isTablet ? ' ' : ''}
              </TextPromo>
              <TextPromo color="white" size={!isMobile ? 's24' : 's16'} fontFamily="ASLHauss">
                {t(getKey('на всех этапах'))}
              </TextPromo>
            </div>
          </>
        ) : (
          <div id={SCROLL_TO_ID.heroForm} className={s.textContainer}>
            <Margin mb={isMobile ? 16 : isTablet ? 24 : 32}>
              <Flex style={{ maxWidth: 761 }}>
                <TextPromo
                  color="white"
                  size={isMobile ? 's20' : isTablet ? 's36' : 's48'}
                  weight="w700"
                  className={s.title}
                >
                  Откройте пункт выдачи с&nbsp;гарантированным доходом
                </TextPromo>
              </Flex>
            </Margin>
            <img src={getImgSrc()} alt="heroImg" className={s.heroImg} />
          </div>
        )}
        {isGeDomain() ? buttonHero() : <LimitedOfferSpecial>{buttonHero()}</LimitedOfferSpecial>}
        {isGeDomain() ? <MapGe /> : <Map />}
      </div>
    </section>
  )
}
